import { useWorkflow, labels } from '../WorkflowContext';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const TIMES = ['9 AM', '10 AM', '11 AM', '1 PM', '2 PM', '3 PM', '4 PM'];

export default function CalendarGrid() {
  const wf = useWorkflow();
  return (
    <div className="calendar-grid">
      <div className="cal-cell cal-head" />
      {DAYS.map((d) => <div key={d} className="cal-cell cal-head">{d}</div>)}
      {TIMES.map((time) => (
        <Row key={time} time={time} events={wf.events} />
      ))}
    </div>
  );
}

function Row({ time, events }: { time: string; events: ReturnType<typeof useWorkflow>['events'] }) {
  return (
    <>
      <div className="cal-cell cal-time">{time}</div>
      {DAYS.map((day) => {
        const evs = events.filter((e) => e.day === day && e.time === time);
        return (
          <div className="cal-cell" key={day + time}>
            {evs.map((e, i) => (
              <div key={i} className={`cal-event dept-${e.dept}`}>
                <strong>{e.title}</strong><br /><span>{labels.dept(e.dept)}</span>
              </div>
            ))}
          </div>
        );
      })}
    </>
  );
}
